



































































































































































import BaseVue from "@/core/BaseVue";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import Telefono from "@/models/telefono.model";
import PersonaTelefono from "@/models/persona/personaTelefono.model";
import NameValue from "@/models/nameValue.model";
import BaseApi from "@/core/HttpResources/BaseApi";
import { AxiosResponse } from "axios";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import { setTimeout } from "timers";
import moment from "moment";
@Component({})
export default class EditarTelefonoComponent extends BaseVue {
  @Prop() readonly personaId!: number;
  private telefono = new Telefono();
  private personaTelefono = new PersonaTelefono();
  private personaTelefonoBaseApi: BaseApi = new BaseApi("PersonaTelefono");
  private telefonoBaseApi: BaseApi = new BaseApi("Telefono");
  private personaTelefonoRepository: BaseRepository<any> = new BaseRepository<
    any
  >("PersonaTelefono");
  private telefonoRepository: BaseRepository<any> = new BaseRepository<any>(
    "Telefono"
  );

  saving = false;
  horarioMatutino: boolean = false;
  horarioVespertino: boolean = false;
  horarioNocturno: boolean = false;
  horarioDiaCompleto: boolean = false;
  reRender: any = true;
  reRenderEdit: any = true;

  horarios = {
    matutino: false,
    vespertino: false,
    nocturno: false,
    diaCompleto: false
  };
  editingTelefono: PersonaTelefono | null = null;
  editingTelefonoIndex = -1;
  telefonos: Telefono[] = [];
  personaTelefonos: PersonaTelefono[] = [];
  tipoTelefono = new NameValue();
 getValueTime(value: string) {
    return moment(value).format("LT");
  }
  @Watch("horarioMatutino", { immediate: true })
  onHorarioMatutinoChange(value: any) {
    if (value) {
      this.horarioDiaCompleto = false;
    }
  }
 
  @Watch("horarioVespertino", { immediate: true })
  onHorarioVespertinoChange(value: any) {
    if (value) {
      this.horarioDiaCompleto = false;
    }
  }

  @Watch("horarioNocturno", { immediate: true })
  onHorarioNocturnoChange(value: any) {
    if (value) {
      this.horarioDiaCompleto = false;
    }
  }

  setHorarios() {
    this.horarios.matutino = this.horarioMatutino;
    this.horarios.vespertino = this.horarioVespertino;
    this.horarios.nocturno = this.horarioNocturno;
    this.horarios.diaCompleto = this.horarioDiaCompleto;
  }

  setHorariosToPersonaTelefono() {
    this.setHorarios();
    this.personaTelefono.matutino = this.horarios.matutino;
    this.personaTelefono.vespertino = this.horarios.vespertino;
    this.personaTelefono.nocturno = this.horarios.nocturno;
    this.personaTelefono.diaCompleto = this.horarios.diaCompleto;
  }

  mostrarEditar(diaCompleto: any, i: any) {
    return true;
  }

  @Watch("horarioDiaCompleto", { immediate: true })
  onDiaCompletoChange(value: any) {
    if (value) {
      this.horarioMatutino = false;
      this.horarioVespertino = false;
      this.horarioNocturno = false;
      this.reRender = null;
    }
    this.reRender = true;
  }

  mounted() {
    this.refreshTable();
  }

  refreshTable() {
    if (this.personaId) {
      let id = this.personaId;
      this.personaTelefonoBaseApi.request(
        "get",
        `GetByPersonaId/${id}`,
        null,
        { id },
        (response: AxiosResponse) => {
          this.personaTelefonos = [];
          this.personaTelefonos = response.data as any;
        }
      );
    }
  }

  async addTelefono(tel: Telefono) {
    var isValid = await this.$validator.validateAll();
    if (!isValid) {
      this.operationNoAllowed("Debe llenar tipo y número de teléfono");
      return;
    }

    if (
      this.personaTelefonos.some(
        (x: any) =>
          x.telefono.numero === tel.numero &&
          x.telefono.extension === tel.extension
      )
    ) {
      this.operationNoAllowed("No se permiten teléfonos repetidos");
      return;
    }
    try {
      this.saving = true;

      this.telefonoRepository.create(tel).then(responseTelefono => {
        if (responseTelefono) {
          this.personaTelefono.telefonoId = responseTelefono.id;
          this.personaTelefono.personaId = this.personaId;
          this.personaTelefono.telefono = undefined;
          this.setHorariosToPersonaTelefono();
          this.personaTelefonoRepository
            .create(this.personaTelefono)
            .then(responsePersonaTelefono => {
              if (responsePersonaTelefono) {
                this.refreshTable();
                this.telefono = new Telefono();
                this.personaTelefono = new PersonaTelefono();
                this.horariosInit();
                this.saving = false;
                this.$buefy.toast.open({
                  message: "Teléfono agregado correctamente.",
                  type: "is-success",
                  position: "is-top-right"
                });
              }
            });
        }
      });
    } catch (e) {
      this.saving = false;
    }
  }

  removeTelefono(value: any, index: number) {
    this.$buefy.dialog.confirm({
      title: "Confirmación",
      message: "¿Desea eliminar este teléfono?",
      confirmText: "Adelante!",
      cancelText: "Cancelar",
      type: "is-danger",
      size: "is-medium",
      hasIcon: true,
      onConfirm: () => {
        this.saving = true;
        try {
          this.personaTelefonoRepository.delete(value.id).then(response => {
            if (response) {
              this.saving = false;

              this.refreshTable();
              this.$buefy.toast.open({
                message: "Teléfono eliminado correctamente.",
                type: "is-success",
                position: "is-top-right"
              });
            }
          });
        } catch (e) {
          this.saving = false;
        }
      }
    });
  }

  horariosInit() {
    this.horarios.matutino = false;
    this.horarios.vespertino = false;
    this.horarios.nocturno = false;
    this.horarios.diaCompleto = false;
    this.horarioMatutino = false;
    this.horarioVespertino = false;
    this.horarioNocturno = false;
    this.horarioDiaCompleto = false;
  }

  async editTelefono(value: any, index: number) {
    var isValid =
      value.telefono.numero &&
      value.telefono.numero.length == 10 &&
      value.telefono.tipoTelefono &&
      value.telefono.tipoTelefono.id;
    if (!isValid) {
      this.operationNoAllowed("Debe llenar tipo y número de teléfono");
      return;
    }
    let existeEseNumero = false;
    this.personaTelefonos.forEach((each, i) => {
      if (each.telefono) {
        if (i !== index) {
          if (
            each.telefono.numero == value.telefono.numero &&
            each.telefono.extension == value.telefono.extension
          ) {
            this.operationNoAllowed("No se permiten teléfonos repetidos");
            existeEseNumero = true;
          }
        }
      }
    });
    if (!existeEseNumero) {
      try {
        this.saving = true;
        this.personaTelefonoRepository
          .update(value.id, value)
          .then(response => {
            if (response) {
              this.saving = false;

              this.editingTelefonoIndex = -1;
              this.editingTelefono = null;
              this.refreshTable();
              this.$buefy.toast.open({
                message: "Teléfono editado correctamente.",
                type: "is-success",
                position: "is-top-right"
              });
            }
          });
      } catch (e) {
        this.saving = false;
      }
    }
  }

  @Watch("editingTelefono.matutino", { immediate: true })
  onEditingTelefonoMatutino() {
    if (this.editingTelefono) {
      if (this.editingTelefono.matutino) {
        this.personaTelefonos[this.editingTelefonoIndex].diaCompleto = false;
      }
    }
  }

  @Watch("editingTelefono.vespertino", { immediate: true })
  onEditingTelefonoVespertino() {
    if (this.editingTelefono) {
      if (this.editingTelefono.vespertino) {
        this.personaTelefonos[this.editingTelefonoIndex].diaCompleto = false;
      }
    }
  }

  @Watch("editingTelefono.nocturno", { immediate: true })
  onEditingTelefonoNocturno() {
    if (this.editingTelefono) {
      if (this.editingTelefono.nocturno) {
        this.personaTelefonos[this.editingTelefonoIndex].diaCompleto = false;
      }
    }
  }

  @Watch("editingTelefono.diaCompleto", { immediate: true })
  onEditingTelefonoDiaCompleto() {
    if (this.editingTelefono) {
      if (this.editingTelefono.diaCompleto) {
        this.personaTelefonos[this.editingTelefonoIndex].matutino = false;
        this.personaTelefonos[this.editingTelefonoIndex].vespertino = false;
        this.personaTelefonos[this.editingTelefonoIndex].nocturno = false;
      }
    }
  }

  setTelefonoToEdit(props: any) {
    this.editingTelefonoIndex = props.index;
    this.editingTelefono = props.row;
  }
}
